import Link from 'next/link'

import { ButtonType } from '@/lib/models/components/buttonLink.types'

import { ButtonIcon } from './ButtonIcon.component'
import { ButtonIconText } from './ButtonIconText.component'
import { IconType } from './Icon.types'

interface ButtonLinkProps {
  className?: string
  children?: React.ReactNode
  linkUrl?: string
  anchorClassName?: string
  buttonType?: ButtonType
  ariaLabel?: string
  noIcon?: boolean
}

export const ButtonLinkInternal = ({
  children,
  className,
  anchorClassName,
  linkUrl: href = '/',
  buttonType = ButtonType.PRIMARY,
  ariaLabel,
  noIcon,
}: ButtonLinkProps) => {
  return (
    <Link href={href} className={anchorClassName}>
      {children && (
        <ButtonIconText
          className={className}
          iconType={IconType.arrow_right}
          variant={buttonType}
          noIcon={noIcon}
        >
          {children}
        </ButtonIconText>
      )}
      {!children && (
        <ButtonIcon
          className={className}
          iconType={IconType.arrow_right}
          variant={buttonType}
          ariaLabel={ariaLabel && ariaLabel}
        />
      )}
    </Link>
  )
}
